// @ts-strict-ignore
import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {emitTrackEvent} from 'common/util/dom';

import {Section, SectionItem} from '../items-menu/types';
import {TagAttrs} from '../tag/types';
import {template} from './template';
import css from './index.inline.styl';

interface HeaderAttrs {
  title: string;
  description?: string;
  actions?: SectionItem[];
  'overflow-actions'?: Section[];
  'show-back-button'?: boolean;
  tags?: TagAttrs[];
  'can-edit'?: boolean;
  'tracking-prefix'?: string;
}

type HeaderJsxProps = {
  attrs: HeaderAttrs;
  on?: {
    actionclick?: (ev) => void;
  };
};

export class Header extends Component<unknown, HeaderAttrs> {
  static get attrsSchema(): AttrsSchema<HeaderAttrs> {
    return {
      ...super.attrsSchema,
      description: {type: `string`, description: `The description`},
      title: {type: `string`, description: `The title`},
      actions: {type: `json`, description: `Array of SectionItem actions`},
      'overflow-actions': {type: `json`, description: `Array of Sections to display in the overflow menu`},
      tags: {type: `json`, description: `Tags to show below title`},
      'can-edit': {type: `boolean`, description: `Set to true if title and description should be editable`},
      'tracking-prefix': {
        type: `string`,
        description: `Prefix to append to track calls originating from this component`,
      },
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      helpers: {
        handleActionClick: (detail) => {
          this.track(`Action Clicked`, {name: detail.value});
          this.dispatchEvent(new CustomEvent(`actionclick`, {detail}));
        },
        handleEditClick: () => {
          this.dispatchEvent(new CustomEvent(`edit`));
        },
        getHeaderActionItemsSlots: () => {
          return this.attr(`actions`)
            ? this.attr(`actions`).filter((item) => Object.prototype.hasOwnProperty.call(item, `slot`))
            : [];
        },
      },
    };
  }

  private track(event: string, props: Obj = {}) {
    emitTrackEvent(this, {
      eventName: event,
      eventPrefix: this.attr(`tracking-prefix`) || `mp-header`,
      props: {
        ...props,
      },
      cancelable: true,
    });
  }
}

export const HeaderEl = defineAndMakeJsxFactory<HeaderJsxProps>(`mp-header`, Header);
export const HeaderReact = panel2react<HeaderJsxProps>(`mp-header`, Header);
